import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import Multiselect from "multiselect-react-dropdown";
import Swal from "sweetalert2";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { toast } from "react-toastify";
import { get } from "lodash";
import ImagePopup from "../ImagePopUp";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const [locations, setLocations] = useState([]);
  const dispatch = useDispatch();
  const [dynamicFieldsError, setDynamicFieldsError] = useState("");
  const [shippingFieldsError, setShippingFieldsError] = useState("");
  const multiselectRef = useRef(null);
  const [formData, setFormData] = useState({
    orderId: "",
    firstName: "",
    orderDate: new Date(),
    type: "",
    channelName: "",
    businessName: "",
    contactNo: "",
    email: "",
    address: "",
    poNo: "",
    poRemark: "",
    poDate: "",
    paymentTerms: "",
    distributorName: "",
    termsAndConditions: "",
    authPersonName: "",
    shippingAddress: "",
    shippingMethod: "",
    shippingAddressList: "",
    godown: "",
    mobileNo: "",
    subject: "",
    orderStatus: "In Order",
    orderNotes: "",
    note: "",
    officeLocation: "",
    officeAddress: "",
    officeName: "",
    officeEmail: "",
    officeCity: "",
    officeDistrict: "",
    officeState: "",
    officePincode: "",
    officeGstuni: "",
  });
  const [nameList, setNameList] = useState([]);
  const [validated, setValidated] = useState(false);
  const [godid, setGodid] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [category, setcategory] = useState([]);
  const [item, setItem] = useState([]);
  const [terms, setTerms] = useState("");
  const [priceList, setPriceList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [godownList, setGodownList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemList, setItemList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [isShipmentValid, setIsShipmentValid] = useState(true);
  const [distributorsList, setDistributorsList] = useState([]);
  const [emergencyContactError, setEmergencyContactError] = useState(false);
  const [shippingInformation, setShippingInformation] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [deletedProducts, setDeletedProducts] = useState([]);
  const [deletedMaterial, setDeletedMaterial] = useState([]);
  const [deletedShipment, setDeletedShipment] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const [isChannelNameValid, setIsChannelNameValid] = useState(true);
  const [shippingFields, setShippingFields] = useState([
    { item: "", quantity: "", maxQuantity: 0, id: "0" },
  ]);
  const [dynamicFields, setDynamicFields] = useState([
    {
      category: "",
      product: "",
      salesPrice: "",
      mrp: "",
      discountedPrice: "",
      qty: "",
      productList: [],
      id: "0",
      status: "",
      index: 1,
    },
  ]);
  const [popupImage, setPopupImage] = useState(null);
  const [marketingDynamic, setMarketingDynamic] = useState([
    {
      item: "",
      item_image: "",
      qty: "",
      id: "0",
      status: "",
      marketPrice: "",
    },
  ]);

  // const handleDeleteShipment = (index) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Once deleted, you will not be able to recover this data!",
  //     icon: "warning",
  //     showDenyButton: true,
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {

  //       setShippingInformation((prevInfo) =>
  //         prevInfo.map((item, i) =>
  //           i === index ? { ...item, status: "deleted" } : item
  //         )
  //       );
  //     }
  //   });
  // };

  const handleDeleteShipment = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setShippingInformation((prevInfo) => {
          const updatedInfo = [...prevInfo];
          const [deletedItem] = updatedInfo.splice(index, 1); // Remove the item from shippingInformation
          setDeletedShipment((prevDeleted) => [...prevDeleted, deletedItem]);
          setIsShipmentValid(updatedInfo.length > 0); // Add to deletedShipment
          return updatedInfo;
        });
      }
    });
  };

  const columns = [
    {
      name: "Shipment",
      selector: (row, index) =>
        "Shipment   " + (shippingInformation.indexOf(row) + 1),
    },
    {
      name: "Total Quantity",
      selector: (row) => row.totalQuantity,
    },

    {
      name: "Address",
      selector: (row) => row.shippingAddress,
    },
    {
      name: "Shipping Method",
      selector: (row) => row.shippingMethod,
    },

    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-circle"
            variant="outline-danger"
            size="sm"
            onClick={() =>
              handleDeleteShipment(shippingInformation.indexOf(row))
            }
          >
            <Delete />
          </RB.Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    //  getQuotationList();
    getcategory();
    getItemList();

    // if (props.comp === "add") getTerms();
  }, [isEdit]);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getProductList = (val, index) => {
    utils
      .callAPI("get", `/Product/productCatList?categoryId=${val}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDynamicFields((prevFields) => {
            const newFields = [...prevFields];
            if (newFields[index]) {
              newFields[index].productList = res.result;
            }
            return newFields;
          });
        } else {
          setDynamicFields((prevFields) => {
            const newFields = [...prevFields];
            if (newFields[index]) {
              newFields[index].productList = [];
            }
            return newFields;
          });
        }
      })
      .catch((err) => {
        setDynamicFields((prevFields) => {
          const newFields = [...prevFields];
          if (newFields[index]) {
            newFields[index].productList = [];
          }
          return newFields;
        });
      });
  };

  const getPriceList = (value, index) => {
    utils
      .callAPI("get", `/Product/coupon-value?product_id=${value}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          let price = res.regularPrice || "";

          const fields = [...dynamicFields];
          fields[index].mrp = price;
          fields[index].discountedPrice = price;
          setDynamicFields(fields);
        } else {
          const fields = [...dynamicFields];
          fields[index].mrp = "";
          fields[index].discountedPrice = "";
          setDynamicFields(fields);
        }
      })
      .catch((err) => {
        const fields = [...dynamicFields];
        fields[index].mrp = "";
        fields[index].discountedPrice = "";
        setDynamicFields(fields);
      });
  };

  const getItemList = (index) => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", "");
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getmarketingList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setItemList(res.result);
        } else {
          setItemList([]);
        }
      })
      .catch((err) => {
        setItemList([]);
      });
  };

  const getItemPrice = (id, index) => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", id);
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getmarketingList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          let itemPrice = res.result[0].item_price || "";
          let img = res.result[0].item_image || "";
          const fields = [...marketingDynamic];
          fields[index].item_image = img;
          fields[index].marketPrice = itemPrice;

          setMarketingDynamic(fields);
        } else {
          const fields = [...marketingDynamic];
          fields[index].marketPrice = "";
          setMarketingDynamic(fields);
        }
      })
      .catch((err) => {
        const fields = [...marketingDynamic];
        fields[index].marketPrice = "";
        setMarketingDynamic(fields);
      });
  };

  const getcategory = () => {
    utils
      .callAPI("get", `/Product/categoryList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setcategory(res);
        } else {
          setcategory([]);
        }
      })
      .catch((err) => {
        setcategory([]);
      });
  };

  const handleSelect = (selectedList) => {
    if (selectedList.length > 0) {
      setFormData({
        ...formData,
        channelName: selectedList[0].cat, // Always take the first one
      });
      setIsChannelNameValid(true);
    }
  };

  const handleRemove = (selectedList) => {
    setFormData({
      ...formData,
      channelName: "",
    });
    setIsChannelNameValid(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    const isOnlyDigits = /^\d+$/.test(value);

    if (name === "officeLocation") {
      setFormData({
        ...formData,
        officeLocation: validatedValue,
      });
      return;
    }

    if (name === "mobileNo") {
      validatedValue = value.replace(/\D/g, "");

      setEmergencyContactError(validatedValue.length !== 10);
      // // Restrict input to 10 digits
      // if (validatedValue.length > 10) {
      //   validatedValue = validatedValue.slice(0, 10);
      // }
    }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });

    updateValidationErrors(name, value);
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const validateChannelPartner = () => {
    if (formData.channelName.length === 0) {
      setIsChannelNameValid(false);
      return false;
    }
    setIsChannelNameValid(true);
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const IsChannelNameValid = validateChannelPartner();

    const totalShippingQty = shippingInformation
      ?.map((x) => parseFloat(x.totalQuantity))
      ?.reduce((acc, qty) => acc + qty, 0);

    const totalProductQty = dynamicFields.reduce((total, field) => {
      const qty = parseFloat(field.qty);
      return total + (isNaN(qty) ? 0 : qty);
    }, 0);

    if (
      form.checkValidity() === false ||
      !IsChannelNameValid ||
      shippingInformation.length === 0 ||
      totalShippingQty < totalProductQty
    ) {
      e.stopPropagation();
      setValidated(true);

      setIsShipmentValid(shippingInformation.length > 0); // Trigger the error message

      if (totalShippingQty < totalProductQty) {
        Swal.fire({
          title: "Error",
          text: "The Total Quantity in shipping information cannot be less than the Total Product Quantity.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else {
      setIsSubmit(true);
    }
  };

  const handleMarketDynamic = (index, event) => {
    const { name, value } = event.target;
    const fields = marketingDynamic.filter(
      (field) => field.status !== "deleted",
    );

    let validatedValue = value;

    if (name === "qty") {
      // Only allow digits and prevent the value from being just '0'
      validatedValue = value.replace(/\D/g, "");
      if (validatedValue === "0") {
        validatedValue = ""; // Clear the value if it's just '0'
      }
    }

    if (name === "item") {
      if (!value) {
        // If dropdown cleared, reset all fields in that row
        fields[index] = {
          item: "",
          item_image: "",
          qty: "",
          id: fields[index].id || "0",
          status: fields[index].status || "",
          marketPrice: "",
        };
      } else {
        getItemPrice(value, index);
      }
    }
    fields[index][name] = validatedValue;
    console.log("Here is the ifeld", fields);
    setMarketingDynamic(fields);
  };

  const handleDynamicFieldChange = (index, event) => {
    const { name, value } = event.target;
    const fields = dynamicFields.filter((field) => field.status !== "deleted");

    if (name === "qty") {
      const isValidQty = /^\d+$/.test(value); // Only digits are allowed, and it shouldn't be just '0'

      if (isValidQty && value !== "0") {
        fields[index][name] = value;
      } else if (value === "") {
        fields[index][name] = value; // Allow clearing the input
      }
    } else if (name === "category") {
      fields[index][name] = value;
      getProductList(value, index);
    } else if (name === "product") {
      fields[index][name] = value;
      getPriceList(value, index);
    } else if (name === "discountedPrice") {
      const isValidSalesPrice = /^\d*\.?\d{0,2}$/.test(value); // Allow numbers with up to two decimal places
      if (isValidSalesPrice || value === "") {
        fields[index][name] = value;
      }
    } else if (name === "mrp") {
      const numericValue = parseFloat(value);
      if ((numericValue >= 0 || value === "") && /^\d*\.?\d*$/.test(value)) {
        fields[index][name] = value;
      }
    } else {
      fields[index][name] = value;
    }
    setDynamicFields(fields);

    if (dynamicFields.length >= 1) {
      setDynamicFieldsError("");
    }
  };

  const handleAddField = () => {
    setDynamicFields([
      ...dynamicFields,
      {
        category: "",
        product: "",
        salesPrice: "",
        mrp: "",
        discountedPrice: "",
        qty: "",
        productList: [],
        id: "0",
        status: "",
      },
    ]);

    setDynamicFieldsError("");
  };

  const calculateTotalPrice = (salesPrice, qty) => {
    const price = parseFloat(salesPrice);
    const quantity = parseFloat(qty);
    if (!isNaN(price) && !isNaN(quantity)) {
      return (price * quantity).toFixed(2);
    }
    return "0.00";
  };

  const totalQty = dynamicFields.reduce((total, field) => {
    const qty = parseFloat(field.qty);
    return total + (isNaN(qty) ? 0 : qty);
  }, 0);

  const totalMarketQty = marketingDynamic.reduce((total, field) => {
    const qty = parseFloat(field.qty);
    return total + (isNaN(qty) ? 0 : qty);
  }, 0);

  const totalPrice = dynamicFields.reduce((total, field) => {
    const salesPrice = parseFloat(field.discountedPrice);
    const qty = parseFloat(field.qty);

    return total + (isNaN(salesPrice) || isNaN(qty) ? 0 : salesPrice * qty);
  }, 0);

  const totalMarketPrice = marketingDynamic.reduce((total, field) => {
    const price = parseFloat(field.marketPrice);
    const qty = parseFloat(field.qty);

    return total + (isNaN(price) || isNaN(qty) ? 0 : price * qty);
  }, 0);

  // const totalPrice = dynamicFields.

  const handleAddMarketingField = () => {
    setMarketingDynamic([
      ...marketingDynamic,
      {
        item: "",
        qty: "",
        item_image: "",
        id: "",
        marketPrice: "",
      },
    ]);
    //  setDynamicFieldsError("");
  };

  const handleRemoveMarketingField = (index, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const fields = [...marketingDynamic];
        if (id > 0) {
          const deletedMaterial = fields.find((field) => field.id === id);

          // Update the deleted products array
          setDeletedMaterial((prevDeletedMaterial) => [
            ...prevDeletedMaterial,
            deletedMaterial,
          ]);
        }

        if (id > 0) {
          const removeIndex = fields.findIndex((field) => field.id === id);
          if (removeIndex > -1) fields.splice(removeIndex, 1);
        } else {
          fields.splice(index, 1);
        }

        setMarketingDynamic(fields);
      }
    });
  };

  const handleShippingFieldChange = (index, event, field = null) => {
    const { name, value } = event.target;
    const fields = [...shippingFields];
    let validatedValue = value;

    if (name === "quantity") {
      // calculateRemainingQuantity(field.item);
      const maxQuantity = calculateRemainingQuantity(field);

      const quantityValue = parseFloat(value);
      if (
        !isNaN(quantityValue) &&
        quantityValue <= maxQuantity &&
        quantityValue !== 0
      ) {
        validatedValue = value.replace(/\D/g, ""); // Remove non-numeric characters
      } else {
        validatedValue = ""; // Reset if exceeds max quantity
      }
    }

    fields[index][name] = validatedValue;

    setShippingFields(fields);
    updateValidationErrors(`${name}_${index}`, value);
    setSelectedProducts((prevSelectedProducts) => {
      // Check if the selected product ID is already in the array
      if (!prevSelectedProducts.includes(value)) {
        return [...prevSelectedProducts, value];
      }
      return prevSelectedProducts;
    });
    if (shippingFields.length >= 1) {
      setShippingFieldsError("");
    }
  };

  const handleAddShippingField = () => {
    setShippingFields([
      ...shippingFields,
      { item: "", quantity: "", maxQuantity: 0, id: "0" },
    ]);

    setShippingFieldsError("");
  };

  const handleRemoveShippingField = (index) => {
    if (shippingFields.length === 1) {
      setShippingFieldsError("At least one item must be present.");
      return;
    }
    setShippingFieldsError("");

    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const fields = shippingFields.filter((_, i) => i !== index);
        setShippingFields(fields);
      }
    });
  };

  const handleRemoveField = (index, id) => {
    if (dynamicFields.length === 1) {
      setDynamicFieldsError("At least one product must be present.");
      return;
    }
    setDynamicFieldsError("");
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Copy the dynamicFields array
        const fields = [...dynamicFields];

        // Determine the deleted product
        if (id > 0) {
          const deletedProduct = fields.find((field) => field.id === id);

          // Update the deleted products array
          setDeletedProducts((prevDeletedProducts) => [
            ...prevDeletedProducts,
            deletedProduct,
          ]);
        }
        // Remove the product from the fields array
        if (id > 0) {
          const removeIndex = fields.findIndex((field) => field.id === id);
          if (removeIndex > -1) fields.splice(removeIndex, 1);
        } else {
          fields.splice(index, 1);
        }

        // Update the dynamicFields state
        setDynamicFields(fields);
      }
    });
  };

  // useEffect(() => {
  //   if (isSubmit) {
  //     var bodyFormData = new FormData();
  //     if (isEdit) {
  //       bodyFormData.append("id", props?.rowData?.id);
  //     }
  //     bodyFormData.append("channel_partner_type", formData.type);
  //     bodyFormData.append("channel_partner_id", formData.channelName);
  //     bodyFormData.append("channel_partner_name", formData.authPersonName);
  //     bodyFormData.append("channel_partner_email", formData.email);
  //     bodyFormData.append("channel_partner_no", formData.mobileNo);
  //     bodyFormData.append("payment_terms", formData.paymentTerms);
  //     bodyFormData.append("order_notes", formData.orderNotes);
  //     bodyFormData.append("order_total_qty", totalQty);
  //     // bodyFormData.append("order_status", formData.orderStatus);
  //     bodyFormData.append("order_total", totalPrice.toFixed(2));
  //     bodyFormData.append("order_by", userProfile?.employeeId);

  //     bodyFormData.append("po_no", formData.poNo);
  //     bodyFormData.append(
  //       "po_date",
  //       formData.poDate ? moment(formData.poDate).format("YYYY-MM-DD") : ""
  //     );
  //     bodyFormData.append("po_remarks", formData.poRemark);
  //     bodyFormData.append("terms_condition", formData.termsAndConditions);
  //     dynamicFields.forEach((field, index) => {
  //       bodyFormData.append(`category_id[${index + 1}]`, field.category || "");
  //       bodyFormData.append(`product_id[${index + 1}]`, field.product || "");
  //       bodyFormData.append(`original_price[${index + 1}]`, field.mrp || "");
  //       bodyFormData.append(
  //         `sales_price[${index + 1}]`,
  //         field.discountedPrice || "0"
  //       );
  //       bodyFormData.append(`product_qty[${index + 1}]`, field.qty || "0");
  //     });

  //     marketingDynamic.forEach((field, index) => {
  //       bodyFormData.append(
  //         `marketing_material_id[${index + 1}]`,
  //         field.item || ""
  //       );
  //       bodyFormData.append(`qty[${index + 1}]`, field.qty || "");
  //     });

  //     shippingInformation.forEach((field, index) => {
  //       bodyFormData.append(
  //         `shipment_name[${index + 1}]`,
  //         `Shipment ${index + 1}` || ""
  //       );
  //       bodyFormData.append(
  //         `total_qty[${index + 1}]`,
  //         field.totalQuantity || "0"
  //       );
  //       bodyFormData.append(
  //         `shipment_method[${index + 1}]`,
  //         field.shippingMethod || "0"
  //       );
  //       bodyFormData.append(
  //         `total_qty[${index + 1}]`,
  //         field.totalQuantity || "0"
  //       );
  //       bodyFormData.append(`godown_id[${index + 1}]`, field.godown);
  //       bodyFormData.append(`address[${index + 1}]`, field.shippingAddress);
  //       bodyFormData.append(
  //         `address_type[${index + 1}]`,
  //         field.shippingAddressList
  //       );
  //       field.items.forEach((field, innerindex) => {
  //         bodyFormData.append(
  //           `item_name[${index + 1}][${innerindex + 1}]`,
  //           field.item || ""
  //         );
  //         bodyFormData.append(
  //           `item_qty[${index + 1}][${innerindex + 1}]`,
  //           field.quantity || ""
  //         );
  //       });

  //       //          shippingAddress: formData.shippingAddress,
  //       // shippingMethod: formData.shippingMethod,
  //       // shippingAddressList: formData.shippingAddressList,
  //       // totalQuantity: totalQuantity,
  //       // godown: formData.godown,
  //       // items: shippingFields,
  //     });

  //     utils
  //       .callAPI(
  //         "post",
  //         `/sales/save_orders
  //       `,
  //         bodyFormData
  //       )
  //       .then((res) => {
  //         if (typeof res !== "undefined") {
  //           setIsSubmit(false);
  //           setisEdit(false);
  //           const propdata = {
  //             mode: "list",
  //           };
  //           props.onChange(propdata);
  //         } else {
  //           setIsSubmit(false);
  //         }
  //       })
  //       .catch((err) => {
  //         setIsSubmit(false);
  //       });
  //   }
  // }, [isSubmit]);

  useEffect(() => {
    if (isSubmit) {
      const requestData = {
        id: isEdit ? props?.rowData?.id : "0",
        order_date: moment(formData?.orderDate).format("YYYY-MM-DD"),
        channel_partner_type: formData.type,
        channel_partner_id: formData.channelName,
        channel_partner_name: formData.authPersonName,
        channel_partner_email: formData.email,
        channel_partner_no: formData.mobileNo,
        payment_terms: formData.paymentTerms,
        order_notes: formData.orderNotes,
        order_total_qty: totalQty,
        order_total: totalPrice.toFixed(2),
        order_by: userProfile?.employeeId,
        location_id: formData.officeLocation || "",
        material_total_qty: totalMarketQty,
        material_total: totalMarketPrice.toFixed(2),

        po_no: formData.poNo,
        po_date: formData.poDate
          ? moment(formData.poDate).format("YYYY-MM-DD")
          : "",
        po_remarks: formData.poRemark,

        product: dynamicFields.map((field, index) => ({
          id: field.id || "0",
          category_id: field.category || "",
          product_id: field.product || "",
          original_price: field.mrp || "",
          sales_price: field.discountedPrice || "0",
          qty: field.qty || "0",
        })),
        product_delete: isEdit
          ? deletedProducts.map((field, index) => ({
              id: field.id || "0",
              category_id: field.category || "",
              product_id: field.product || "",
              original_price: field.mrp || "",
              sales_price: field.discountedPrice || "0",
              qty: field.qty || "0",
            }))
          : "",

        material: marketingDynamic.map((field, index) => ({
          id: field.id || "0",
          marketing_material_id: field.item || "",
          qty: field.qty || "",
          price: field.marketPrice || "",
          total: "",
          status: field.status ? field.status : "",
        })),

        material_delete: isEdit
          ? deletedMaterial.map((field, index) => ({
              id: field.id || "0",
              marketing_material_id: field.item || "",
              qty: field.qty || "",
              price: field.marketPrice || "",
              total: "",
              status: field.status ? field.status : "",
            }))
          : "",

        shipment: shippingInformation.map((field, index) => ({
          id: field.id || "0",
          shipment_name: `Shipment ${index + 1}` || "",
          total_qty: field.totalQuantity || "0",
          shipment_method: field.shippingMethod || "0",
          godown_id: field.godown,
          address: field.shippingAddress,
          address_type: field.shippingAddressList,
          status: field.status ? field.status : "",
          items: field.items.map((item, innerIndex) => ({
            id: item.id || "0",
            item_name: item.item || "",
            item_qty: item.quantity || "",
          })),
        })),

        shipment_delete: isEdit
          ? deletedShipment.map((field, index) => ({
              id: field.id || "0",
              shipment_name: `Shipment ${index + 1}` || "",
              total_qty: field.totalQuantity || "0",
              shipment_method: field.shippingMethod || "0",
              godown_id: field.godown,
              address: field.shippingAddress,
              address_type: field.shippingAddressList,
              status: field.status ? field.status : "",
              items: field.items.map((item, innerIndex) => ({
                id: item.id || "0",
                item_name: item.item || "",
                item_qty: item.quantity || "",
              })),
            }))
          : "",
      };

      // Remove undefined fields
      const cleanedRequestData = JSON.parse(
        JSON.stringify(requestData, (key, value) =>
          value === undefined ? undefined : value,
        ),
      );

      utils
        .callAPI("post", "/sales/save_orders", cleanedRequestData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = { mode: "list" };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);
      //Here i want to update dynammic fields from prop

      if (props.rowData.product && props.rowData.product.length > 0) {
        props.rowData.product.forEach((product, index) => {
          getProductList(product.category_id, index);
        });

        setDynamicFields(
          props.rowData.product.map((product) => ({
            category: product.category_id,
            product: product.product_id,
            discountedPrice: product.sales_price,
            mrp: product.original_price,
            qty: product.qty,
            id: product.id,
          })),
        );
      } else {
        setDynamicFields([
          {
            category: "",
            product: "",
            salesPrice: "",
            mrp: "",
            discountedPrice: "",
            qty: "",
            id: "0",
            status: "",
          },
        ]);
      }

      if (props.rowData.material && props.rowData.material.length > 0) {
        setMarketingDynamic(
          props.rowData.material.map((material) => ({
            item: material.marketing_material_id,
            qty: material.qty,
            item_image: material.material_item_image,
            id: material.id,
            marketPrice: material.price,
          })),
        );
      } else {
        setMarketingDynamic([
          {
            item: "",
            item_image: "",
            qty: "",
            id: "",
            marketPrice: "",
          },
        ]);
      }

      if (props.rowData.shipment && props.rowData.shipment.length > 0) {
        //          shippingAddress: formData.shippingAddress,
        // shippingMethod: formData.shippingMethod,
        // shippingAddressList: formData.shippingAddressList,
        // totalQuantity: totalQuantity,
        // godown: formData.godown,
        // items: shippingFields,
        setShippingInformation(
          props.rowData.shipment.map((shipment) => ({
            shippingMethod: shipment.shipment_method,
            totalQuantity: shipment.total_qty,
            godown: shipment.godown_id,
            shippingAddressList: shipment.address_type,
            shippingAddress: shipment.address,
            id: shipment.id,

            items: shipment.items.map((item) => ({
              item: item.item_name,
              quantity: item.item_qty,
              id: item.id,
            })),
          })),
        );
      }

      setFormData({
        officeLocation: props?.rowData?.location_id || "",
        firstName: props?.rowData?.firstName || "",
        channelName: props?.rowData?.channel_partner_id || "",
        authPersonName: props?.rowData?.channel_partner_name || "",
        mobileNo: props?.rowData?.channel_partner_no || "",
        type: props?.rowData?.channel_partner_type || "",
        email: props?.rowData?.channel_partner_email || "",
        orderDate: props?.rowData?.order_date || "",
        orderId: props?.rowData?.order_id || "",
        orderNotes: props?.rowData?.order_notes || "",
        orderStatus: props?.rowData?.order_status || "",
        paymentTerms: props?.rowData?.payment_terms || "",
        poNo: props?.rowData?.po_no || "",
        poDate: props?.rowData?.po_date || "",
        poRemark: props?.rowData?.po_remarks || "",
      });
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const getQuotationList = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("userId", userProfile?.employeeId);
    bodyFormData.append("id", "");
    bodyFormData.append("vendor_type", formData.type);
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getsalesFormList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDistributorsList(res.result.companyName);

          setNameList(res.result);
          if (formData.channelName !== "") {
          }
        } else {
          setNameList([]);
        }
      })
      .catch((err) => {
        setNameList([]);
      });
  };

  // useEffect(() => {
  //   setFormData({
  //     authPersonName: props?.rowData?.channel_partner_name || "",
  //     mobileNo: props?.rowData?.channel_partner_no || "",
  //       email: props?.rowData?.channel_partner_email || "",
  //   })
  // }, [props.rowData.channel_partner_no,props?.rowData?.channel_partner_name, props?.rowData?.channel_partner_email])

  // Replace existing getChannelDetailList with this
  const getChannelDetailList = (id = "", { preserveList = false } = {}) => {
    const bodyFormData = new FormData();
    bodyFormData.append("userId", userProfile?.employeeId);
    bodyFormData.append("id", id || ""); // id may be empty -> return full list
    bodyFormData.append("vendor_type", formData.type);
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getsalesFormbyid`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          // ONLY replace the options when preserveList === false
          if (!preserveList) {
            setDistributorsList(res.result.companyName);
            setNameList(res.result);
          }

          // If an id was requested, pull the single record for details
          if (id) {
            const rec =
              Array.isArray(res.result) &&
              (res.result.find((r) => String(r.id) === String(id)) ||
                res.result[0]);

            if (rec) {
              getGodownList(id);
              setFormData((prev) => ({
                ...prev,
                authPersonName:
                  props?.rowData?.channel_partner_id === rec.id
                    ? props?.rowData?.channel_partner_name
                    : rec?.authorised_person_name || "",
                mobileNo:
                  props?.rowData?.channel_partner_id === rec.id
                    ? props?.rowData?.channel_partner_no
                    : rec?.authorised_contact_no || "",
                email:
                  props?.rowData?.channel_partner_id === rec.id
                    ? props?.rowData?.channel_partner_email
                    : rec?.authorised_email || "",
              }));
            } else {
              // no record found: clear details
              setFormData((prev) => ({
                ...prev,
                authPersonName: "",
                mobileNo: "",
                email: "",
              }));
            }
          } else {
            // if no id requested (we fetched full list) you may want to clear details
            setFormData((prev) => ({
              ...prev,
              // keep existing details only if you want; here we clear to be safe
              authPersonName: "",
              mobileNo: "",
              email: "",
            }));
          }
        } else {
          if (!preserveList) setNameList([]);
          setFormData((prev) => ({
            ...prev,
            authPersonName: "",
            mobileNo: "",
            email: "",
          }));
        }
      })
      .catch((err) => {
        if (!preserveList) setNameList([]);
        setFormData((prev) => ({
          ...prev,
          authPersonName: "",
          mobileNo: "",
          email: "",
        }));
      });
  };

  useEffect(() => {
    if (formData.type && formData.type !== "none") {
      // fetch full list for the selected vendor type
      getChannelDetailList("", { preserveList: false });
    }
    if (formData.type === "none") {
      setFormData((prev) => ({
        ...prev,
        channelName: "",
        authPersonName: "",
        mobileNo: "",
        email: "",
      }));
    }
  }, [formData.type]);

  // useEffect(() => {
  //   // if (formData.channelName === "") {
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     // channelName: "",
  //     authPersonName: "",
  //     mobileNo: "",
  //     email: "",
  //   }));

  // }, [formData.type, formData.channelName]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (formData?.channelName === "" || formData?.type === "none") {
        setFormData((prevFormData) => ({
          ...prevFormData,
          authPersonName: "",
          mobileNo: "",
          email: "",
        }));
      }
    }, 100); // Adjust delay as necessary

    return () => clearTimeout(timer);
  }, [formData.channelName, formData.type]);

  useEffect(() => {
    setGodownList([]);
    setFormData((prevFormData) => ({
      ...prevFormData,
      shippingAddress: "",
    }));

    if (formData.channelName !== "") {
      // Preserve full dropdown list — fetch only details
      getChannelDetailList(formData.channelName, { preserveList: true });
    }
  }, [formData.channelName]);

  useEffect(() => {
    if (formData.channelName && formData.godown)
      getGodownAddress(formData.channelName, formData.godown);
  }, [formData.godown]);

  useEffect(() => {
    if (totalMarketPrice !== "" && totalPrice !== "") {
      const per = (totalMarketPrice / totalPrice) * 100;

      // if (parseFloat(per) > 0 && parseFloat(per) <= 100) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        note: (
          <>
            As per the sales order, marketing budget is{" "}
            <strong>{isNaN(per) ? "0.00" : per.toFixed(2)}%</strong> against the
            total sales value.
          </>
        ),
      }));
      // } else {
      //   setFormData((prevFormData) => ({
      //     ...prevFormData,
      //     note: "",
      //   }));
      // }
    }
  }, [marketingDynamic, dynamicFields, totalMarketPrice, totalPrice]);

  const getGodownAddress = (channelId, godownId) => {
    var bodyFormData = new FormData();

    bodyFormData.append("dealership_id", channelId);
    bodyFormData.append("id", godownId);
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getgodownList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setFormData((prevFormData) => ({
            ...prevFormData,
            shippingAddress: res.result[0]?.godown_address,
          }));
        } else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            shippingAddress: "",
          }));
        }
      })
      .catch((err) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          shippingAddress: "",
        }));
      });
  };

  const getGodownList = (id) => {
    var bodyFormData = new FormData();

    bodyFormData.append("dealership_id", id);
    bodyFormData.append("id", "");
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getgodownList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setGodownList(res.result);
        } else {
          setGodownList([]);
        }
      })
      .catch((err) => {
        setGodownList([]);
      });
  };

  useEffect(() => {
    getLocationList();
  }, []);

  useEffect(() => {
    if (formData.officeLocation && locations.length > 0) {
      setAdditionalFields(formData.officeLocation);
    }
  }, [formData.officeLocation, locations]);

  const getLocationList = () => {
    var bodyFormData = new FormData();

    //  bodyFormData.append("id", props?.rowData?.id);
    // bodyFormData.append("page");
    // bodyFormData.append("per_page");

    utils
      .callAPI("get", `/sales/getLocationList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setLocations(res.result);
        } else {
          setLocations([]);
        }
      })
      .catch((err) => {
        setLocations([]);
      });
  };

  const setAdditionalFields = (locationId) => {
    const selectedLocation = locations.find(
      (location) => location.id === locationId,
    );

    setFormData({
      ...formData,
      officeAddress: selectedLocation ? selectedLocation.address : "",
      officeName: selectedLocation ? selectedLocation.name : "",
      officeEmail: selectedLocation
        ? selectedLocation.contact_person_email
        : "",
      officeCity: selectedLocation ? selectedLocation.city : "",
      officeDistrict: selectedLocation ? selectedLocation.district : "",
      officeState: selectedLocation ? selectedLocation.state : "",
      officePincode: selectedLocation ? selectedLocation.pincode : "",
      officeGstuni: selectedLocation ? selectedLocation.gst_uni : "",
    });
  };

  const handleAddShipment = () => {
    let errorMessage = "";

    if (formData.authPersonName === "") {
      errorMessage += "<li>Authorised Person Name is required.</li>";
    }
    if (formData.channelName === "") {
      errorMessage += "<li>Channel Partner Name is required.</li>";
    }
    if (
      dynamicFields.length === 0 ||
      dynamicFields.some(
        (field) => field.category === "" || field.product === "",
      )
    ) {
      errorMessage += "<li>At least one product is required.</li>";
    }
    if (
      dynamicFields.length === 0 ||
      dynamicFields.some((field) => field.qty === "")
    ) {
      errorMessage += "<li>Product Quantity is required.</li>";
    }
    if (formData.mobileNo === "") {
      errorMessage += "<li>Mobile Number is required.</li>";
    }
    if (formData.email === "") {
      errorMessage += "<li>Email is required.</li>";
    }

    if (errorMessage !== "") {
      Swal.fire({
        title: "Missing Fields",
        html: `<ul style="text-align: left; list-style-position: inside; padding-left: 0;">${errorMessage}</ul>`,
        icon: "warning",
        confirmButtonText: "OK",
        // customClass: {
        //   title: "swal-title-left-align",
        // },
      });
    } else {
      setSelectedProducts([]);
      setFormData((prevFormData) => ({
        ...prevFormData,
        shippingAddress: "",
        shippingMethod: "",
        shippingAddressList: "",
        godown: "",
      }));

      setShowModal(true);
    }
  };

  const handleItemSelect = (index, event) => {
    const { name, value } = event.target;
    const selectedItem = dynamicFields?.find(
      (item) => item.product === event.target.value,
    );
    const fields = [...shippingFields];
    fields[index].item = event.target.value;
    fields[index].maxQuantity = selectedItem ? selectedItem.qty : 0;
    setShippingFields(fields);
    updateValidationErrors(`${name}_${index}`, value);
  };

  const totalQuantity = shippingFields.reduce((total, field) => {
    const quantity = parseFloat(field.quantity);
    return total + (isNaN(quantity) ? 0 : quantity);
  }, 0);

  const updateValidationErrors = (name, value) => {
    setValidationErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value) {
        delete newErrors[name];
      } else {
        // Extract the field name without index for the error message
        const fieldName = name.replace(/_\d+$/, ""); // Removes the trailing _0, _1, etc.

        // Mapping for specific field name changes
        const specialNamesMapping = {
          shippingAddressList: "Type",
        };

        // Format the field name or use the mapped name if it exists
        const formattedFieldName = specialNamesMapping[fieldName]
          ? specialNamesMapping[fieldName]
          : fieldName
              .replace(/([A-Z])/g, " $1")
              .trim()
              .replace(/^./, (str) => str.toUpperCase());

        newErrors[name] = `${formattedFieldName} is required`;
      }
      return newErrors;
    });
  };

  const calculateTotalShippingQuantity = (productId) => {
    let totalQuantity = 0;
    shippingFields.forEach((field) => {
      if (field.item === productId) {
        totalQuantity += parseInt(field.quantity);
      }
    });

    return totalQuantity;
  };

  const handleSaveShipment = () => {
    const errors = {};

    // Check for validation errors
    if (!formData.shippingAddress)
      errors.shippingAddress = "Shipping Address is required";
    if (!formData.shippingMethod)
      errors.shippingMethod = "Shipping Method is required";
    if (!formData.shippingAddressList)
      errors.shippingAddressList = "Shipping Address List is required";
    if (formData.shippingAddressList === "Godown" && !formData.godown)
      errors.godown = "Godown is required";
    if (!totalQuantity) errors.totalQuantity = "Total Quantity is required";

    shippingFields.forEach((field, index) => {
      if (!field.item) errors[`item_${index}`] = "Item is required";

      if (!field.quantity) errors[`quantity_${index}`] = "Quantity is required";
    });

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    const newShippingInfo = {
      shippingAddress: formData.shippingAddress,
      shippingMethod: formData.shippingMethod,
      shippingAddressList: formData.shippingAddressList,
      totalQuantity: totalQuantity,
      godown: formData.godown,
      items: shippingFields,
    };

    setSelectedProducts([]);
    setShippingFields([{ item: "", maxQuantity: "", quantity: "", id: "0" }]);
    setShippingInformation((prevInfo) => [...prevInfo, newShippingInfo]);
    setShowModal(false); // Close the modal
    setValidationErrors({}); // Clear validation errors
    setIsShipmentValid(true);
  };

  const onCloseModal = () => {
    setSelectedProducts([]);
    setShippingFields([{ item: "", maxQuantity: "", quantity: "", id: "0" }]);
    setShippingFieldsError("");
    setShowModal(false);
    setValidationErrors({});
  };

  const calculateRemainingQuantity = (productId) => {
    // Find the total quantity available in dynamicFields

    const dynamicField = dynamicFields.find(
      (field) => field.product === productId,
    );

    const availableQuantity = dynamicField ? parseInt(dynamicField.qty) : 0;

    // Calculate the total quantity already assigned in shippingFields
    let assignedQuantity = 0;
    if (shippingInformation !== "") {
      shippingInformation.forEach((field) => {
        field.items.forEach((item) => {
          if (item.item === productId) {
            assignedQuantity += parseInt(item.quantity);
          }
        });
      });
    }

    // Calculate the remaining quantity
    const remainingQuantity = availableQuantity - assignedQuantity;

    return remainingQuantity > 0 ? remainingQuantity : 0;
  };

  const filteredShippingInformation = shippingInformation.filter(
    (item) => item.status !== "deleted",
  );

  const openPopup = (image) => setPopupImage(image);

  const closePopup = () => setPopupImage(null);

const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "transparent",
    // 1. Remove all default borders
    border: "none",
    borderRadius: 0,
    // 2. Apply only the bottom border
    // Uses #86b7fe (Bootstrap focus blue) when active, else standard grey
    borderBottom: state.isFocused ? "2px solid #86b7fe" : "1px solid #dee2e6",
    minHeight: '48px',
    // 3. Remove the blue "halo" / glow
    boxShadow: "none",
    transition: "border-color 0.2s ease",
    "&:hover": {
      // Keep or slightly darken the underline on hover
      borderBottom: state.isFocused ? "2px solid #86b7fe" : "1px solid #ced4da",
    },
  }),
  // Remove the small vertical line next to the dropdown arrow for a cleaner look
  indicatorSeparator: () => ({
    display: "none",
  }),
  // Align the text/placeholder to the left (removing default padding)
  valueContainer: (base) => ({
    ...base,
    paddingLeft: 0,
  }),
  // Align the dropdown arrow/clear button to the right
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: 0,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  placeholder: (base) => ({
    ...base,
    color: '#6c757d',
    marginLeft: 0,
  })
};
  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>{isEdit ? "Edit" : "Add"}</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Destination Center"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      name="officeLocation"
                      className="form-control form-select"
                      value={formData.officeLocation}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Destination Center...</option>
                      {locations?.map((location, index) => (
                        <option key={index} value={location.id}>
                          {location.name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                {formData.officeAddress ? (
                  <>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Office Address
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {formData?.officeName}
                      <br />
                      {formData?.officeAddress},<br />
                      {formData?.officeCity},<br />
                      {formData.officeState} - {formData.officePincode}
                      <br />
                      {/* GSTIN/UIN: {formData?.gstUin} <br />
                    State Name : {formData?.state}, Code : {formData?.stateCode} */}
                    </p>
                  </>
                ) : (
                  ""
                )}
              </RB.Col>
            </RB.Row>

            <RB.Row>
              <RB.Col md={6} className="no-validation-icon">
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Order Id"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      name="code"
                      value={
                        props.comp === "add"
                          ? "Auto Generated"
                          : formData.orderId
                      }
                      readOnly
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6} className="no-validation-icon">
                <div className="mb-3 mt-3">
                  <RB.FloatingLabel
                    label="Order Date"
                    className={`floating-label-fancy ${
                      formData.orderDate ? "dateSelected" : "dateempty"
                    }`}
                  >
                    <DatePicker
                      selected={formData.orderDate}
                      onChange={(date) =>
                        setFormData({ ...formData, orderDate: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      // placeholderText="Order Date"
                      required
                      readOnly
                      maxDate={moment().toDate()}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <h6>PO Details</h6>
              <RB.Row>
                <RB.Col md={4} className="no-validation-icon">
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="PO Number"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter PO Number"
                        name="poNo"
                        value={formData.poNo}
                        onChange={handleInputChange}
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={4} className="no-validation-icon">
                  <div className="mb-3 mt-3">
                    <RB.FloatingLabel
                      label="PO Date"
                      className={`floating-label-fancy ${
                        formData.poDate ? "dateSelected" : "dateempty"
                      }`}
                    >
                      <DatePicker
                        selected={formData.poDate}
                        onChange={(date) =>
                          setFormData({ ...formData, poDate: date })
                        }
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        // placeholderText="Order Date"

                        //   maxDate={moment().toDate()}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={4} className="no-validation-icon">
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="PO Remark"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as="textarea"
                        type="text"
                        placeholder="Enter PO Remark"
                        name="poRemark"
                        value={formData.poRemark}
                        onChange={handleInputChange}
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
              <h6>Channel Partner Details</h6>

              <RB.Col md={6} className="no-validation-icon">
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Channel Partner"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="none">Channel Partner...</option>
                      <option value="Dealer">Dealer</option>
                      <option value="Distributor">Distributor</option>
                      <option value="Retailer">Retailer</option>
                      <option value="Key Accounts">Key Accounts</option>
                      <option value="PRO">PRO</option>
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6} className="no-validation-icon">
                <div
                  className={
                    formData.channelName === "" ? "mb-3 mt-4" : "mb-3 mt-3"
                  }
                >
                  <RB.FloatingLabel
                    //label="Channel Partner Name"
                    className="floating-label-fancy"
                  >
                    <Select
                      name="channelName"
                      options={
                        Array.isArray(nameList)
                          ? nameList.map((name) => ({
                              value: name.id,
                              label: name.companyName,
                            }))
                          : []
                      }
                      value={
                        formData.channelName
                          ? {
                              value: formData.channelName,
                              label:
                                nameList.find(
                                  (n) => n.id === formData.channelName,
                                )?.companyName || "",
                            }
                          : null
                      }
                      onChange={(selectedOption) => {
                        const selectedId = selectedOption
                          ? selectedOption.value
                          : "";

                        setFormData((prev) => ({
                          ...prev,
                          channelName: selectedId,
                        }));
                        setIsChannelNameValid(!!selectedOption);

                        if (selectedId) {
                          // fetch details for this id but KEEP the full nameList (options)
                          getChannelDetailList(selectedId, {
                            preserveList: true,
                          });
                        } else {
                          // cleared: reset dependent fields
                          setFormData((prev) => ({
                            ...prev,
                            authPersonName: "",
                            mobileNo: "",
                            email: "",
                          }));
                          setGodownList([]);
                        }
                      }}
                      placeholder="Channel Partner Name..."
                      /* styles & props unchanged */
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />

                    {!isChannelNameValid && (
                      <div className="text-danger mt-1">
                        Please select at least one Channel Partner Name.
                      </div>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Channel Partner Contact</h6>
            <RB.Row>
              <RB.Col md={4} className="no-validation-icon">
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Authorised Person Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Authorised Person Name"
                      name="authPersonName"
                      value={formData.authPersonName}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4} className="no-validation-icon">
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Mobile No"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Mobile No"
                      name="mobileNo"
                      value={formData.mobileNo}
                      onChange={handleInputChange}
                      required
                      maxLength={10}
                      disabled={!!formData.mobileNo}
                    />
                    {emergencyContactError ? (
                      <span className="text-danger">
                        {" "}
                        Please provide a valid Mobile Number.
                      </span>
                    ) : (
                      ""
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={4} className="no-validation-icon">
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Email"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            {/* <RB.Form.Group
              // as={RB.Row}
              className="mb-3 mt-2"
              controlId="formHorizontalDynamicFields"
            > */}
            <RB.Card>
              <RB.CardBody className="p-3">
                <div className="d-md-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h6 className="mb-2 mb-md-0">Products</h6>
                  <RB.Button variant="light" onClick={handleAddField}>
                    <AddCircleOutline className="me-2" />
                    Add Product
                  </RB.Button>
                </div>
                {dynamicFields.map((field, index) => (
                  <RB.Card className="mb-2 bg-light-subtle1 border-0 border-bottom card rounded-0 border-dashed custom-width-component">
                    <RB.CardBody className="p-0">
                      <RB.Row className="gx-3 gy-2 align-items-center">
                        <RB.Col className="col-12 col-md-5 col-lg-5 col-xl-2 col-xxl-3 no-validation-icon">
                          <div className="mb-3">
                            <RB.FloatingLabel
                              label="Product Category"
                              className="floating-label-fancy"
                            >
                              <RB.Form.Control
                                as="select"
                                name="category"
                                className="form-control form-select form-select-sm"
                                value={field.category}
                                onChange={(e) =>
                                  handleDynamicFieldChange(index, e)
                                }
                                required
                              >
                                <option value="">Category...</option>
                                {category.map((product) => (
                                  <option key={product.id} value={product.id}>
                                    {product.productCategoryName}
                                  </option>
                                ))}
                              </RB.Form.Control>
                            </RB.FloatingLabel>
                          </div>
                        </RB.Col>
                        <RB.Col className="col-12 col-md-5 col-lg-5 col-xl-4 col-xxl-3 no-validation-icon">
                          <div className="mb-2">
                           
                            <Select
                              name="product"
                              classNamePrefix="react-select"
                              options={field.productList?.map((product) => ({
                                value: product.id,
                                label: `${product.product_name} ${product?.size} ${product?.unit?.toUpperCase()}`,
                                isDisabled: dynamicFields
                                  .slice(0, index)
                                  .some((f) => f.product === product.id),
                              }))}
                              value={
                                field.product
                                  ? {
                                      value: field.product,
                                      label: field.productList?.find(
                                        (p) => p.id === field.product,
                                      )?.product_name, // Simplify as needed
                                    }
                                  : null
                              }
                              onChange={(selectedOption) => {
                                const syntheticEvent = {
                                  target: {
                                    name: "product",
                                    value: selectedOption
                                      ? selectedOption.value
                                      : "",
                                  },
                                };
                                handleDynamicFieldChange(index, syntheticEvent);
                              }}
                              placeholder="Select Product..."
                              isClearable
                              menuPortalTarget={document.body}
                              styles={customStyles}
                            />
                          </div>
                        </RB.Col>
                        {/* <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon ">
                          <div className="mb-3">
                            <RB.FloatingLabel
                              label="Actual Price"
                              className="floating-label-fancy"
                            >
                              <RB.Form.Control
                                type="text"
                                placeholder="Enter MRP"
                                name="mrp"
                                value={field.mrp}
                                onChange={(e) =>
                                  handleDynamicFieldChange(index, e)
                                }
                                required
                                readOnly
                              />
                            </RB.FloatingLabel>
                          </div>
                        </RB.Col> */}
                        <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-2 col-xxl-2 no-validation-icon">
                          <div className="mb-3">
                            <RB.FloatingLabel
                              label="Basic Price"
                              className="floating-label-fancy"
                            >
                              <RB.Form.Control
                                type="text"
                                placeholder="Enter Discounted Price"
                                name="discountedPrice"
                                value={field.discountedPrice}
                                onChange={(e) =>
                                  handleDynamicFieldChange(index, e)
                                }
                              />
                            </RB.FloatingLabel>
                          </div>
                        </RB.Col>

                        <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon">
                          <div className="mb-3">
                            <RB.FloatingLabel
                              label="Quantity"
                              className="floating-label-fancy"
                            >
                              <RB.Form.Control
                                type="text"
                                placeholder="Enter Quantity"
                                name="qty"
                                value={field.qty}
                                onChange={(e) =>
                                  handleDynamicFieldChange(index, e)
                                }
                                required
                              />
                            </RB.FloatingLabel>
                          </div>
                        </RB.Col>
                        <RB.Col className="col-12 col-md-3 col-lg-4 col-xl-2 col-xxl-2 w-auto no-validation-icon">
                          <div className="mb-3">
                            <RB.FloatingLabel
                              label="Total Price"
                              className="floating-label-fancy"
                            >
                              <RB.Form.Control
                                type="text"
                                placeholder="Enter Discounted Price"
                                name="discountedPrice"
                                value={`${calculateTotalPrice(
                                  field.discountedPrice,
                                  field.qty,
                                )}`}
                                // onChange={(e) =>
                                //   handleDynamicFieldChange(index, e)
                                // }
                                readOnly
                              />
                            </RB.FloatingLabel>
                          </div>
                        </RB.Col>
                        <RB.Col className="col-12 col-md-auto col-lg-auto col-xl-auto col-xxl-auto no-validation-icon">
                          <RB.Button
                            variant="link"
                            className="text-dark p-0"
                            onClick={() => handleRemoveField(index, field.id)}
                          >
                            <DeleteOutline />
                          </RB.Button>
                          {/* {dynamicFields.length - 1 === index && (
                          <RB.Button
                            variant="outline-dark"
                            className="btn-sm"
                            onClick={handleAddField}
                          >
                            <AddCircleOutline />
                          </RB.Button>
                        )} */}
                        </RB.Col>
                      </RB.Row>
                    </RB.CardBody>
                  </RB.Card>
                ))}
                {/* <RB.Row className="g-3 me-4 justify-content-start align-items-center custom-half-width"> */}
                <RB.Row className="g-3  justify-content-end align-items-center">
                  <RB.Col className="col-12 col-md-4 col-xl-2 text-md-end ">
                    <h6 className="mb-0">Total</h6>
                  </RB.Col>
                  <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon">
                    <div
                      className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                      style={{
                        ...(window.innerWidth >= 1200
                          ? { minWidth: "100px" }
                          : {}),
                      }}
                    >
                      <span class="text-uppercase fw-bold small text-body-secondary">
                        Quantity
                      </span>
                      <p class="fw-medium text-sm fw-semibold mb-0">
                        {totalQty}
                      </p>
                    </div>
                  </RB.Col>
                  <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon ">
                    <div
                      className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                      style={{
                        ...(window.innerWidth >= 1200
                          ? { minWidth: "180px", marginRight: 30 }
                          : {}),
                      }}
                    >
                      <span class="text-uppercase fw-bold small text-body-secondary ">
                        Price
                      </span>
                      <p class="fw-medium text-sm fw-semibold mb-0">{`${totalPrice.toFixed(
                        2,
                      )}`}</p>
                    </div>
                  </RB.Col>
                </RB.Row>
                {dynamicFieldsError && (
                  <RB.Row>
                    <RB.Col>
                      <span className="text-danger">{dynamicFieldsError}</span>
                    </RB.Col>
                  </RB.Row>
                )}
              </RB.CardBody>
            </RB.Card>
            {/* </RB.Form.Group> */}

            {/* <RB.Form.Group
              as={RB.Row}
              className="mb-3 mt-2"
              controlId="formHorizontalDynamicFields"
            >
              <h6>Products</h6>

              <RB.Table
                responsive
                bordered
                size="sm"
                className="table text-nowrap"
              >
                <thead>
                  <tr>
                    <th>Product Category</th>
                    <th>Product</th>
                    <th>Actual Price</th>
                    <th>Sales Price</th>
                    <th>Quantity</th>
                    <th>Total Price</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dynamicFields.map((field, index) => (
                    <tr key={index}>
                      <td>
                        <RB.Form.Control
                          as="select"
                          name="category"
                          className="form-select "
                          value={field.category}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                          required
                        >
                          <option value="">Select Category...</option>
                          {category.map((product) => (
                            <option key={product.id} value={product.id}>
                              {product.productCategoryName}
                            </option>
                          ))}
                        </RB.Form.Control>
                      </td>
                      <td>
                        <RB.Form.Control
                          as="select"
                          name="product"
                          className="form-select"
                          value={field.product}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                          required
                        >
                          <option value="">Select Product...</option>
                          {field.productList?.map((product) => (
                            <option key={product.id} value={product.id}>
                              {product.product_name +
                                ` (${product?.size}${" " + product?.unit})`}
                            </option>
                          ))}
                        </RB.Form.Control>
                      </td>
                      <td>
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter MRP"
                          name="mrp"
                          value={field.mrp}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                          required
                          readOnly
                        />
                      </td>
                      <td>
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Discounted Price"
                          name="discountedPrice"
                          value={field.discountedPrice}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                        />
                      </td>
                      <td>
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Quantity"
                          name="qty"
                          value={field.qty}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                          required
                        />
                      </td>
                      <td>{`Rs ${calculateTotalPrice(
                        field.discountedPrice,
                        field.qty
                      )}`}</td>
                      <td>
                        <RB.Button
                          variant="outline-danger"
                          className="btn-sm me-2"
                          onClick={() => handleRemoveField(index)}
                        >
                          <DeleteOutline />
                        </RB.Button>
                        {dynamicFields.length - 1 === index && (
                          <RB.Button
                            variant="outline-dark"
                            className="btn-sm"
                            onClick={handleAddField}
                          >
                            <AddCircleOutline />
                          </RB.Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="4" className="text-end fw-bold">
                      Total
                    </td>
                    <td>{totalQty}</td>
                    <td>{`Rs ${totalPrice.toFixed(2)}`}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </RB.Table>

              {dynamicFieldsError && (
                <RB.Row>
                  <RB.Col>
                    <span className="text-danger">{dynamicFieldsError}</span>
                  </RB.Col>
                </RB.Row>
              )}
            </RB.Form.Group> */}

            <RB.Row>
              <h6>Payment Terms</h6>

              <RB.Col md={6} className="no-validation-icon">
                <div className="mb-3">
                  <RB.FloatingLabel
                    //  label="Payment Terms"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="paymentTerms"
                      value={formData.paymentTerms}
                      className="form-control form-select"
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Payment Terms...</option>
                      <option value="Advance Payment">Advance Payment</option>
                      <option value="07 Days">07 Days</option>
                      <option value="15 Days">15 Days</option>
                      <option value="30 Days">30 Days</option>
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Card>
              <RB.CardBody>
                <div className="d-md-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h6 className="mb-2 mb-md-0">Marketing Material</h6>
                  <RB.Button variant="light" onClick={handleAddMarketingField}>
                    <AddCircleOutline className="me-2" />
                    Add Item
                  </RB.Button>
                </div>
                {marketingDynamic?.length > 0 && (
                  <>
                    {marketingDynamic
                      .filter((field) => field.status !== "deleted")
                      .map((field, index) => (
                        <RB.Card className="mb-2 bg-light-subtle1 border-0 border-bottom card rounded-0 border-dashed">
                          <RB.CardBody className="p-0">
                            <RB.Row className="gx-3 gy-2 align-items-center">
                              <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon ">
                                <div className="mb-3">
                                  <RB.FloatingLabel
                                    label="Item"
                                    className="floating-label-fancy"
                                  >
                                    <RB.Form.Control
                                      as="select"
                                      name="item"
                                      className="form-control form-select form-select-sm"
                                      value={field.item}
                                      onChange={(e) =>
                                        handleMarketDynamic(index, e)
                                      }
                                    >
                                      <option value="">Category...</option>
                                      {itemList?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                          {item.item_name}
                                        </option>
                                      ))}
                                    </RB.Form.Control>
                                  </RB.FloatingLabel>
                                </div>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 col no-validation-icon">
                                <div className="mb-3">
                                  <RB.FloatingLabel
                                    label="Image"
                                    className="floating-label-fancy"
                                  >
                                    {field.item_image &&
                                    field.item_image.trim() !== "" ? (
                                      <div
                                        className="form-control text-truncate"
                                        style={{
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        <div
                                          onClick={() =>
                                            openPopup(field.item_image)
                                          }
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                            overflow: "hidden",
                                            width: "35px",
                                            height: "30px",
                                          }}
                                        >
                                          <img
                                            src={field.item_image}
                                            alt="Thumbnail"
                                            style={{
                                              width: "80%",
                                              height: "80%",
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="form-control text-muted">
                                        No Image
                                      </div>
                                    )}
                                  </RB.FloatingLabel>
                                </div>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon ">
                                <div className="mb-3">
                                  <RB.FloatingLabel
                                    label="Price"
                                    className="floating-label-fancy"
                                  >
                                    <RB.Form.Control
                                      type="text"
                                      placeholder="Enter MRP"
                                      name="marketPrice"
                                      value={field.marketPrice}
                                      onChange={(e) =>
                                        handleMarketDynamic(index, e)
                                      }
                                      required
                                      readOnly
                                    />
                                  </RB.FloatingLabel>
                                </div>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 col no-validation-icon">
                                <div className="mb-3">
                                  <RB.FloatingLabel
                                    label="Quantity"
                                    className="floating-label-fancy"
                                  >
                                    <RB.Form.Control
                                      type="text"
                                      placeholder="Enter Quantity"
                                      name="qty"
                                      value={field.qty}
                                      onChange={(e) =>
                                        handleMarketDynamic(index, e)
                                      }
                                    />
                                  </RB.FloatingLabel>
                                </div>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3  no-validation-icon">
                                <div className="mb-3">
                                  <RB.FloatingLabel
                                    label="Total Price"
                                    className="floating-label-fancy"
                                  >
                                    <RB.Form.Control
                                      type="text"
                                      //   placeholder="Enter Discounted Price"
                                      name="marketPrice"
                                      value={`${calculateTotalPrice(
                                        field.marketPrice,
                                        field.qty,
                                      )}`}
                                      // onChange={(e) =>
                                      //   handleDynamicFieldChange(index, e)
                                      // }
                                      readOnly
                                    />
                                  </RB.FloatingLabel>
                                </div>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-auto col-lg-auto col-xl-auto col-xxl-auto">
                                <RB.Button
                                  variant="link"
                                  className="text-dark p-0"
                                  onClick={() =>
                                    handleRemoveMarketingField(index, field.id)
                                  }
                                >
                                  <DeleteOutline />
                                </RB.Button>
                                {/* {marketingDynamic.length - 1 === index && (
                                <RB.Button
                                  variant="outline-dark"
                                  className="btn-sm"
                                  onClick={handleAddMarketingField}
                                >
                                  <AddCircleOutline />
                                </RB.Button>
                              )} */}
                              </RB.Col>
                            </RB.Row>
                          </RB.CardBody>
                        </RB.Card>
                      ))}

                    <RB.Row
                      className="g-3 me-md-5 
                     justify-content-end align-items-center"
                    >
                      <RB.Col className="col-12 col-md-4 col-xl-2 text-md-end ">
                        <h6 className="mb-0">Total</h6>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon">
                        <div
                          className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                          style={{
                            ...(window.innerWidth >= 1200
                              ? { minWidth: "100px" }
                              : {}),
                          }}
                        >
                          <span class="text-uppercase fw-bold small text-body-secondary">
                            Quantity
                          </span>
                          <p class="fw-medium text-sm fw-semibold mb-0">
                            {totalMarketQty}
                          </p>
                        </div>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon ">
                        <div
                          className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                          style={{
                            ...(window.innerWidth >= 1200
                              ? { minWidth: "180px", marginRight: 30 }
                              : {}),
                          }}
                        >
                          <span class="text-uppercase fw-bold small text-body-secondary ">
                            Price
                          </span>
                          <p class="fw-medium text-sm fw-semibold mb-0">{`${totalMarketPrice.toFixed(
                            2,
                          )}`}</p>
                        </div>
                      </RB.Col>
                    </RB.Row>
                  </>
                )}
              </RB.CardBody>
            </RB.Card>

            {/* {formData.note ? ( */}
            <RB.Row>
              <h6>Note</h6>
              <RB.Col md={12} className="no-validation-icon">
                <div className="mb-3">
                  <div className="form-control" style={{ minHeight: "38px" }}>
                    {formData.note}
                  </div>
                  {/* <RB.FloatingLabel
                    controlId="note"
                    //  label="Order Notes"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      //   placeholder="Enter Note"
                      name="note"
                      value={formData.note}
                      // onChange={handleInputChange}
                      // maxLength={500}
                      readOnly
                    />
                  </RB.FloatingLabel> */}
                </div>
              </RB.Col>
            </RB.Row>
            {/* ) : (
              ""
            )} */}

            {/* {marketingDynamic?.length > 0 && (
              <RB.Form.Group
                as={RB.Row}
                className="mb-3 mt-2"
                controlId="formHorizontalDynamicFields"
              >
                <h6>Select Marketing Material</h6>
                <RB.Table
                  responsive
                  bordered
                  size="sm"
                  className="table-responsive"
                >
                  <thead>
                    <tr>
                      <th>Select Item</th>
                      <th>Quantity</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {marketingDynamic.map((field, index) => (
                      <tr key={index}>
                        <td>
                          <RB.Form.Control
                            as="select"
                            className="form-select"
                            name="item"
                            value={field.item}
                            onChange={(e) => handleMarketDynamic(index, e)}
                          >
                            <option value="">Select Category...</option>
                            {itemList?.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.item_name}
                              </option>
                            ))}
                          </RB.Form.Control>
                        </td>
                        <td>
                          <RB.Form.Control
                            type="text"
                            placeholder="Enter Quantity"
                            name="qty"
                            value={field.qty}
                            onChange={(e) => handleMarketDynamic(index, e)}
                          />
                        </td>
                        <td>
                          <RB.Button
                            variant="outline-danger"
                            className="btn-sm me-2 mt-2"
                            onClick={() => handleRemoveMarketingField(index)}
                          >
                            <DeleteOutline />
                          </RB.Button>
                          {marketingDynamic.length - 1 === index && (
                            <RB.Button
                              variant="outline-dark"
                              className="btn-sm mt-2"
                              onClick={handleAddMarketingField}
                            >
                              <AddCircleOutline />
                            </RB.Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </RB.Table>
              </RB.Form.Group>
            )} */}
            <RB.Row>
              <h6>Order Notes</h6>
              <RB.Col md={12} className="no-validation-icon">
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="orderNotes"
                    //  label="Order Notes"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      type="text"
                      placeholder="Enter Order Notes"
                      name="orderNotes"
                      value={formData.orderNotes}
                      onChange={handleInputChange}
                      maxLength={500}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <RB.Row className="mt-4 align-items-center justify-content-between">
              {!isShipmentValid && (
                <div className="text-danger mt-1">Please Add one Shipment.</div>
              )}

              <RB.Col md={9} className="no-validation-icon">
                <h6>Shipping Information</h6>
              </RB.Col>
              <RB.Col className="col-md-auto">
                <RB.Button
                  variant="outline-dark"
                  className="btn-lg"
                  onClick={handleAddShipment}
                >
                  Add Shippment
                  <AddCircleOutline className="ms-2" />
                </RB.Button>
              </RB.Col>
            </RB.Row>

            <DataTable
              columns={columns}
              data={filteredShippingInformation}
              highlightOnHover
              responsive
              striped
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
            {showModal && (
              <RB.Modal show={showModal} onHide={onCloseModal} size="lg">
                <RB.Modal.Header closeButton>
                  <RB.Modal.Title>Add Shipping Information</RB.Modal.Title>
                </RB.Modal.Header>
                <RB.Modal.Body>
                  <RB.Card>
                    <RB.CardBody className="p-3">
                      <div className="d-md-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                        <h6 className="mb-2 mb-md-0">Items</h6>
                        <RB.Button
                          variant="light"
                          onClick={handleAddShippingField}
                        >
                          <AddCircleOutline className="me-2" />
                          Add Items
                        </RB.Button>
                      </div>
                      {shippingFields.map((field, index) => (
                        <RB.Card className="mb-2 bg-light-subtle1 border-0 border-bottom card rounded-0 border-dashed">
                          <RB.CardBody className="p-0">
                            <RB.Row className="gx-3 gy-2 align-items-center">
                              <RB.Col className="col-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5 no-validation-icon">
                                <div className="mb-3">
                                  <RB.FloatingLabel
                                    label="Product"
                                    className="floating-label-fancy"
                                  >
                                    <RB.Form.Control
                                      as="select"
                                      className="form-control form-select form-select-sm"
                                      name="item"
                                      value={field.item}
                                      onChange={(e) =>
                                        handleItemSelect(index, e)
                                      }
                                    >
                                      <option value="">Product...</option>
                                      {dynamicFields
                                        .filter(
                                          (product) =>
                                            !selectedProducts.includes(
                                              product.product,
                                            ),
                                        )
                                        .map((product) => {
                                          const productDetails =
                                            product.productList?.find(
                                              (item) =>
                                                item.id === product.product,
                                            );
                                          const productName = productDetails
                                            ? productDetails.product_name
                                            : "";
                                          const productSize = productDetails
                                            ? productDetails.size
                                            : "";
                                          const productUnit = productDetails
                                            ? productDetails.unit
                                            : "";
                                          // const totalShippingQuantity =
                                          //   calculateTotalShippingQuantity(
                                          //     product.product
                                          //   );
                                          // const disabled =
                                          //   totalShippingQuantity >=
                                          //   parseInt(product.qty);

                                          const disabled =
                                            calculateRemainingQuantity(
                                              product.product,
                                            ) <= 0;

                                          return product.product !== "" ? (
                                            <option
                                              key={product.product}
                                              value={product.product}
                                              disabled={shippingFields.some(
                                                (f) =>
                                                  (f.item === product.product &&
                                                    f !== field) ||
                                                  disabled,
                                              )}
                                            >
                                              {productName +
                                                ` (${productSize}${
                                                  " " + productUnit
                                                })`}
                                            </option>
                                          ) : (
                                            <option
                                              value=""
                                              disabled
                                              key="empty-option"
                                            >
                                              No products available
                                            </option>
                                          );
                                        })}{" "}
                                    </RB.Form.Control>

                                    {validationErrors[`item_${index}`] && (
                                      <div className="text-danger mt-1">
                                        {validationErrors[`item_${index}`]}
                                      </div>
                                    )}
                                  </RB.FloatingLabel>
                                </div>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 no-validation-icon">
                                <div className="mb-3">
                                  <RB.FloatingLabel
                                    label="Max Quantity"
                                    className="floating-label-fancy"
                                  >
                                    <RB.Form.Control
                                      type="text"
                                      placeholder="Max Quantity"
                                      name="maxQuantity"
                                      value={calculateRemainingQuantity(
                                        field.item,
                                      )}
                                      onChange={(e) =>
                                        handleShippingFieldChange(index, e)
                                      }
                                      readOnly
                                    />
                                    {validationErrors[
                                      `maxQuantity_${index}`
                                    ] && (
                                      <div className="text-danger mt-1">
                                        {""}
                                      </div>
                                    )}
                                  </RB.FloatingLabel>
                                </div>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 no-validation-icon">
                                <div className="mb-3">
                                  <RB.FloatingLabel
                                    label="Quantity"
                                    className="floating-label-fancy"
                                  >
                                    <RB.Form.Control
                                      type="text"
                                      placeholder="Enter Quantity"
                                      name="quantity"
                                      value={field.quantity}
                                      onChange={(e) =>
                                        handleShippingFieldChange(
                                          index,
                                          e,
                                          field.item,
                                        )
                                      }
                                    />
                                    {validationErrors[`quantity_${index}`] && (
                                      <div className="text-danger mt-1">
                                        {validationErrors[`quantity_${index}`]}
                                      </div>
                                    )}
                                  </RB.FloatingLabel>
                                </div>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-auto col-lg-auto col-xl-auto col-xxl-auto no-validation-icon">
                                <div className="mb-3">
                                  <RB.Button
                                    variant="link"
                                    className="text-dark p-0"
                                    onClick={() =>
                                      handleRemoveShippingField(index)
                                    }
                                  >
                                    <DeleteOutline />
                                  </RB.Button>
                                  {/* {dynamicFields.length - 1 === index && (
                          <RB.Button
                            variant="outline-dark"
                            className="btn-sm"
                            onClick={handleAddField}
                          >
                            <AddCircleOutline />
                          </RB.Button>
                        )} */}
                                </div>
                              </RB.Col>
                            </RB.Row>

                            {shippingFieldsError && (
                              <RB.Row>
                                <RB.Col>
                                  <span className="text-danger">
                                    {shippingFieldsError}
                                  </span>
                                </RB.Col>
                              </RB.Row>
                            )}
                          </RB.CardBody>
                        </RB.Card>
                      ))}

                      <RB.Row className="g-3 me-5 justify-content-end align-items-center">
                        <RB.Col className="col-12 col-md-4 col-xl-2 text-md-end">
                          <h6 className="mb-0">Total</h6>
                        </RB.Col>
                        <RB.Col className="col-12 col-md-4 col-xl-2">
                          <div className="bg-light bg-opacity-50 px-2 pe-3 py-1  rounded-3">
                            <span class="text-uppercase fw-bold small text-body-secondary">
                              Quantity
                            </span>
                            <p class="fw-medium text-sm fw-semibold mb-0">
                              {totalQuantity}
                            </p>
                          </div>
                        </RB.Col>
                      </RB.Row>
                    </RB.CardBody>
                  </RB.Card>

                  {/* <RB.Table bordered className="text-nowrap table-sm">
                    <thead>
                      <tr>
                        <th>Select Item</th>
                        <th>Product Quantity</th>
                        <th>Quantity</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shippingFields.map((field, index) => (
                        <tr key={index}>
                          <td>
                            <RB.Form.Control
                              as="select"
                              className="form-select form-select-sm"
                              name="item"
                              value={field.item}
                              onChange={(e) => handleItemSelect(index, e)}
                            >
                              <option value="">Select Product...</option>
                              {dynamicFields
                                .filter(
                                  (product) =>
                                    !selectedProducts.includes(product.product)
                                )
                                .map((product) => {
                                  const productDetails =
                                    product.productList.find(
                                      (item) => item.id === product.product
                                    );
                                  const productName = productDetails
                                    ? productDetails.product_name
                                    : "";
                                  const productSize = productDetails
                                    ? productDetails.size
                                    : "";
                                  const productUnit = productDetails
                                    ? productDetails.unit
                                    : "";

                                  return (
                                    <option
                                      key={product.product}
                                      value={product.product}
                                      disabled={shippingFields.some(
                                        (f) =>
                                          f.item === product.product &&
                                          f !== field
                                      )}
                                    >
                                      {productName +
                                        ` (${productSize}${" " + productUnit})`}
                                    </option>
                                  );
                                })}{" "}
                            </RB.Form.Control>

                            {validationErrors[`item_${index}`] && (
                              <div className="text-danger mt-1">
                                {validationErrors[`item_${index}`]}
                              </div>
                            )}
                          </td>
                          <td>
                            <RB.Form.Control
                              type="text"
                              placeholder="Max Quantity"
                              name="maxQuantity"
                              value={field.maxQuantity}
                              readOnly
                            />
                            {validationErrors[`maxQuantity_${index}`] && (
                              <div className="text-danger mt-1">
                                {validationErrors[`maxQuantity_${index}`]}
                              </div>
                            )}
                          </td>
                          <td>
                            <RB.Form.Control
                              type="text"
                              placeholder="Enter Quantity"
                              name="quantity"
                              value={field.quantity}
                              onChange={(e) =>
                                handleShippingFieldChange(index, e)
                              }
                            />
                            {validationErrors[`quantity_${index}`] && (
                              <div className="text-danger mt-1">
                                {validationErrors[`quantity_${index}`]}
                              </div>
                            )}
                          </td>
                          <td className="">
                            <RB.Button
                              variant="outline-danger"
                              className="btn-sm me-2 mt-2"
                              onClick={() => handleRemoveShippingField(index)}
                            >
                              <DeleteOutline />
                            </RB.Button>
                            {shippingFields.length - 1 === index && (
                              <RB.Button
                                variant="outline-dark"
                                className="btn-sm mt-2"
                                onClick={handleAddShippingField}
                              >
                                <AddCircleOutline />
                              </RB.Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="2" className="text-end fw-bold">
                          Total
                        </td>
                        <td>{totalQuantity}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </RB.Table> */}
                  <RB.Card>
                    <RB.CardBody>
                      <h6>Shipping Address</h6>
                      <RB.Row>
                        <RB.Col
                          md={formData.shippingAddressList === "Godown" ? 4 : 6}
                        >
                          <div className="mb-3">
                            <RB.FloatingLabel
                              label="Type"
                              className="floating-label-fancy"
                            >
                              <RB.Form.Control
                                as="select"
                                name="shippingAddressList"
                                className="form-control form-select form-select-sm"
                                value={formData.shippingAddressList}
                                onChange={handleInputChange}
                                required
                              >
                                <option value="">Type...</option>

                                <option value="Godown">Godown</option>
                                <option value="Site">Site</option>
                                <option value="Office">Office</option>
                              </RB.Form.Control>
                              {validationErrors.shippingAddressList && (
                                <div className="text-danger mt-1">
                                  {validationErrors.shippingAddressList}
                                </div>
                              )}
                            </RB.FloatingLabel>
                          </div>
                        </RB.Col>
                        {formData.shippingAddressList === "Godown" && (
                          <RB.Col md={4}>
                            <div className="mb-3">
                              <RB.FloatingLabel
                                label="Godown"
                                className="floating-label-fancy"
                              >
                                <RB.Form.Select
                                  name="godown"
                                  value={formData.godown}
                                  onChange={handleInputChange}
                                  required
                                >
                                  <option value="">Godown...</option>
                                  {godownList?.length === 0 && (
                                    <option
                                      value=""
                                      disabled
                                      key="empty-option"
                                    >
                                      No Godown available
                                    </option>
                                  )}
                                  {godownList.map((godown, index) => (
                                    <option key={index} value={godown.id}>
                                      {godown.godown_name}
                                    </option>
                                  ))}
                                </RB.Form.Select>
                                {validationErrors.godown && (
                                  <div className="text-danger mt-1">
                                    {validationErrors.godown}
                                  </div>
                                )}
                              </RB.FloatingLabel>
                            </div>
                          </RB.Col>
                        )}
                        <RB.Col
                          md={formData.shippingAddressList === "Godown" ? 4 : 6}
                        >
                          <div className="mb-3">
                            <RB.FloatingLabel
                              label="Shipping Method"
                              className="floating-label-fancy"
                            >
                              <RB.Form.Control
                                type="text"
                                placeholder="Enter Shipping Method"
                                name="shippingMethod"
                                required
                                value={formData.shippingMethod}
                                onChange={handleInputChange}
                              />
                              {validationErrors.shippingMethod && (
                                <div className="text-danger mt-1">
                                  {validationErrors.shippingMethod}
                                </div>
                              )}
                            </RB.FloatingLabel>
                          </div>
                        </RB.Col>
                      </RB.Row>

                      <RB.Row>
                        <RB.Col md={12}>
                          <div className="mb-3">
                            <RB.FloatingLabel
                              label="Shipping Address"
                              className="floating-label-fancy"
                            >
                              <RB.Form.Control
                                as="textarea"
                                type="text"
                                placeholder="Enter Shipping Address"
                                name="shippingAddress"
                                value={formData.shippingAddress}
                                onChange={handleInputChange}
                                required
                              />
                              {validationErrors.shippingAddress && (
                                <div className="text-danger mt-1">
                                  {validationErrors.shippingAddress}
                                </div>
                              )}
                            </RB.FloatingLabel>
                          </div>
                        </RB.Col>
                      </RB.Row>
                    </RB.CardBody>
                  </RB.Card>
                </RB.Modal.Body>
                <RB.Modal.Footer>
                  <RB.Button variant="secondary" onClick={handleSaveShipment}>
                    Save
                  </RB.Button>
                </RB.Modal.Footer>
              </RB.Modal>
            )}

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>

      {popupImage && (
        <ImagePopup
          imageUrl={popupImage}
          // label={"Preview"}
          show={!!popupImage}
          onClose={closePopup}
        />
      )}
    </div>
  );
}

export default Add;
